import { PropsWithChildren, useMemo } from "react";
import { useNavigate } from "react-router-dom";

import { useAuthorization } from "@/Common/hooks/Authorization/Authorization";
import { useLocationId } from "@/Common/hooks/Location/useLocationId";
import { useCurrentUser } from "@/Common/hooks/Users/useCurrentUser";

/**
 * Redirects to /access-denied if user doesn't have access to the current location
 */
const LocationAccessGuard = ({ children }: PropsWithChildren) => {
	const navigate = useNavigate();
	const { useAuth } = useAuthorization();

	const currentUser = useCurrentUser();
	const locationId = useLocationId();

	const hasLocationAccess = useMemo(() => {
		if (!currentUser || !locationId) return true;
		return useAuth(`ACCESS_LOCATION_${locationId}`);
	}, [locationId, currentUser]);

	if (!hasLocationAccess) {
		navigate("/access-denied", { replace: true });
	}

	return <>{children}</>;
};

export default LocationAccessGuard;
